/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerSelectiveDownloadMutationResponse } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerSelectiveDownload";

function getMultiDocumentAgentControllerSelectiveDownloadUrl() {
  const res = { method: 'POST', url: `/api/v1/multi-document-agent/selective-download` as const }  
  return res
}

/**
 * @description Generates a DOCX (or PDF) with only accepted changes applied. Rejected changes are reverted.
 * @summary Download a document with selectively accepted/rejected changes
 * {@link /api/v1/multi-document-agent/selective-download}
 */
export async function multiDocumentAgentControllerSelectiveDownload(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerSelectiveDownloadMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getMultiDocumentAgentControllerSelectiveDownloadUrl().url.toString(), ... requestConfig })  
  return res.data
}